export const PHONE_NUMBER_LENGTH = 8;
export const COUNTRY_CODE = '+968';
